export const PAYMENT_METHOD = {
  WELCOME: 'welcome',
  CARD: 'card',
  OTHER_CARD: 'other-card',
  CASH: 'cash',
  SPEI: 'spei',
  TRANSFER: 'transfer-other-user',
  FAILED_PAYMENT: 'failed-payment',
};

export const PAYMENT_METHODS = Object.values(PAYMENT_METHOD);

export const PAYMENT_METHODS_LIST = [
  {
    id: PAYMENT_METHOD.CARD,
    label: 'Tarjeta',
    icon: 'ion:card',
  },
  {
    id: PAYMENT_METHOD.OTHER_CARD,
    label: 'Tarjeta',
    icon: 'ion:card',
  },
  {
    id: PAYMENT_METHOD.SPEI,
    label: 'SPEI',
    icon: 'mdi:bank',
  },
  {
    id: PAYMENT_METHOD.CASH,
    label: 'Tienda',
    icon: 'fa6-solid:store',
  },
];

export const PAYMENT_STATUS = {
  IDLE: 'idle',
  PROCESSING: 'processing',
  SUCCESS: 'success',
  ERROR: 'error',
  PENDING: 'pending',
};

export const CARD_BRANDS = {
  VISA: 'visa',
  MASTERCARD: 'mastercard',
  AMEX: 'amex',
  DISCOVER: 'discover',
};

export const PUBLIC_KEY = 'key_DHwrIXZ4ublimaLgHO6iHM0';
